import { render, staticRenderFns } from "./MypackNoContent.vue?vue&type=template&id=364d6724&"
import script from "./MypackNoContent.vue?vue&type=script&lang=js&"
export * from "./MypackNoContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports